<template>
    <div id="audit-logs" class="setting-page-content-wrapper audit-logs">
        <div class="page-header">
            <div class="title">{{ $t("auditLogs.auditLogsTitle") }}</div>
            <div class="subtitle">
                {{ $t("auditLogs.auditLogsSub") }}
            </div>
        </div>
        <section>
            <ve-table
                :columns="getColumns()"
                :table-data="activities"
                :row-style-option="rowStyleOption"
                :border-x="true"
                :border-y="true"
                :expand-option="expandOption"
                row-key-field-name="_id"
                id="audit-logs-table"
                :fixed-header="true"
            />
            <div class="actions">
                <SupsisButton primary @click="loadNextPage" small :disabled="loading" v-if="activities.length"
                    >
                    {{ $t("settings.loadMore") }}
                </SupsisButton>
            </div>
        </section>
    </div>
</template>
<script>
import Vue from "vue";
import { ACTIVITY_API } from "../../../../../../api/activity";
import moment from "moment";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere
// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-json";
import "prismjs/themes/prism-tomorrow.css";

// import language config
import SupsisButton from "../../../components/SupsisButton.vue";
import { mapActions, mapState } from "vuex";
import { VeLocale, VePagination } from "vue-easytable";

Vue.use(VePagination);
export default Vue.extend({
    name: "AuditLogs",
    components: { SupsisButton, PrismEditor },
    data(x) {
        return {
            tableConfig: {
                pagination: {
                    goto: "Git",
                    page: "",
                    itemsPerPage: " / sayfa",
                    total: (total) => `Toplam ${total}`,
                    prev5: "Önceki 5 Sayfa",
                    next5: "Sonraki 5 Sayfa",
                },
                table: {
                    // filter
                    confirmFilter: this.$t("chatWindow.filterTable"),
                    resetFilter: this.$t("chatWindow.all"),
                    // contextmenu event
                    cut: "Kes",
                    copy: "Kopyala",
                    insertRowAbove: "Üstüne satır ekle",
                    insertRowBelow: "Altına satır ekle",
                    removeRow: "$1 satırı kaldır",
                    emptyRow: "$1 satırı boşalt",
                    //removeColumn: "Sütunu kaldır",
                    emptyColumn: "$1 sütunu boşalt",
                    //hideColumn: "Sütunu gizle",
                    emptyCell: "Hücreyi boşalt",
                    leftFixedColumnTo: "Sola sabit sütun",
                    cancelLeftFixedColumnTo: "Sola sabit sütunu iptal et",
                    rightFixedColumnTo: "Sağa sabit sütun",
                    cancelRightFixedColumnTo: "Sağa sabit sütunu iptal et",
                },
            },
            loadingInstance: null,
            rowStyleOption: {
                stripe: true,
            },

            filter: {
                actorIds: [],
                startDate: null,
                endDate: null,
                activityTypes: [],
            },
            loading: false,
            activities: [],
            totalCount: 0,
            cursor: {
                page: 1,
                perPage: 50,
            },
            expandOption: {
                render: ({ row, column, rowIndex }, h) => {
                    return h(PrismEditor, {
                        props: {
                            value: JSON.stringify(row.payload || {}, null, 2),
                            class: "my-editor",
                            lineNumbers: true,
                            readOnly: true,
                            highlight: (code) => highlight(code, languages.json),
                        },
                    });
                },
            },
            activityTypes: [
                {
                    value: "blocked",
                    label: "Engellendi",
                },
                {
                    value: "unblocked",
                    label: "Engel kaldırıldı",
                },
                {
                    value: "chat-opened",
                    label: "Sohbet açıldı",
                },
                {
                    value: "chat-closed",
                    label: "Sohbet kapatıldı",
                },
                {
                    value: "chat-rating",
                    label: "Sohbet değerlendirildi",
                },
                {
                    value: "chat-assigned-to-user",
                    label: "Sohbet kullanıcıya atandı",
                },
                {
                    value: "chat-forwarded-to-user",
                    label: "Sohbet kullanıcıya yönlendirildi",
                },
                {
                    value: "contact-owner-updated",
                    label: "Kişi sahibi güncellendi",
                },
                {
                    value: "user-joined-to-chat",
                    label: "Kullanıcı sohbete katıldı",
                },
                {
                    value: "ticket-assigned-to-user",
                    label: "Talep kullanıcıya atandı",
                },
                {
                    value: "online",
                    label: "Çevrimiçi",
                },
                {
                    value: "offline",
                    label: "Çevrimdışı",
                },
                {
                    value: "page-changed",
                    label: "Sayfa değiştirildi",
                },
                {
                    value: "create-ticket",
                    label: "Talep oluşturuldu",
                },
                {
                    value: "video-calling-started",
                    label: "Görüntülü arama başlatıldı",
                },
                {
                    value: "video-calling-closed",
                    label: "Görüntülü arama kapatıldı",
                },
                {
                    value: "voice-calling-started",
                    label: "Sesli arama başlatıldı",
                },
                {
                    value: "voice-calling-closed",
                    label: "Sesli arama kapatıldı",
                },
                {
                    value: "visitor-tag-added",
                    label: "Ziyaretçi etiketi eklendi",
                },
                {
                    value: "visitor-tag-removed",
                    label: "Ziyaretçi etiketi kaldırıldı",
                },
                {
                    value: "note-created",
                    label: "Not oluşturuldu",
                },
                {
                    value: "note-updated",
                    label: "Not güncellendi",
                },
                {
                    value: "visitor-profile-updated",
                    label: "Ziyaretçi profili güncellendi",
                },
                {
                    value: "user-added",
                    label: "Kullanıcı eklendi",
                },
                {
                    value: "user-removed",
                    label: "Kullanıcı kaldırıldı",
                },
                {
                    value: "user-status-changed",
                    label: "Kullanıcı durumu değiştirildi",
                },
                {
                    value: "user-logged-in",
                    label: "Kullanıcı giriş yaptı",
                },
                {
                    value: "user-added-to-department",
                    label: "Kullanıcı departmana eklendi",
                },
                {
                    value: "user-removed-from-depart",
                    label: "Kullanıcı departmandan kaldırıldı",
                },
                {
                    value: "settings-updated",
                    label: "Ayarlar güncellendi",
                },
                {
                    value: "whatsapp-broadcast-created",
                    label: "WhatsApp toplu mesaj oluşturuldu",
                },
                {
                    value: "whatsapp-broadcast-completed",
                    label: "WhatsApp toplu mesaj tamamlandı",
                },
                {
                    value: "whatsapp-broadcast-canceled",
                    label: "WhatsApp toplu mesaj iptal edildi",
                },
                {
                    value: "whatsapp-broadcast-failed",
                    label: "WhatsApp toplu mesaj başarısız oldu",
                },
                {
                    value: "whatsapp-v1-bot-state-changed",
                    label: "WhatsApp v1 bot durumu değiştirildi",
                },
                {
                    value: "whatsapp-v2-bot-state-changed",
                    label: "WhatsApp v2 bot durumu değiştirildi",
                },
                {
                    value: "channel-created",
                    label: "Kanal oluşturuldu",
                },
                {
                    value: "channel-removed",
                    label: "Kanal kaldırıldı",
                },
                {
                    value: "channel-visibility-changed",
                    label: "Kanal görünürlüğü değiştirildi",
                },
                {
                    value: "login-form-activated",
                    label: "Giriş formu etkinleştirildi",
                },
                {
                    value: "login-form-deactivated",
                    label: "Giriş formu devre dışı bırakıldı",
                },
                {
                    value: "login-form-updated",
                    label: "Giriş formu güncellendi",
                },
                {
                    value: "chatbot-created",
                    label: "Chatbot oluşturuldu",
                },
                {
                    value: "chatbot-deleted",
                    label: "Chatbot silindi",
                },
                {
                    value: "chatbot-published",
                    label: "Chatbot yayınlandı",
                },
                {
                    value: "chatbot-webhook-added",
                    label: "Chatbot webhook eklendi",
                },
                {
                    value: "chatbot-webhook-removed",
                    label: "Chatbot webhook kaldırıldı",
                },
                {
                    value: "banned-word-added",
                    label: "Yasaklı kelime eklendi",
                },
                {
                    value: "banned-word-removed",
                    label: "Yasaklı kelime kaldırıldı",
                },
                {
                    value: "mail-address-added",
                    label: "E-posta adresi eklendi",
                },
                {
                    value: "mail-address-removed",
                    label: "E-posta adresi kaldırıldı",
                },
                {
                    value: "mail-was-sent",
                    label: "E-posta gönderildi",
                },
                {
                    value: "content-added",
                    label: "İçerik eklendi",
                },
                {
                    value: "content-removed",
                    label: "İçerik kaldırıldı",
                },
                {
                    value: "role-added",
                    label: "Rol eklendi",
                },
                {
                    value: "role-removed",
                    label: "Rol kaldırıldı",
                },
                {
                    value: "department-added",
                    label: "Departman eklendi",
                },
                {
                    value: "department-removed",
                    label: "Departman kaldırıldı",
                },
                {
                    value: "tags-added",
                    label: "Etiketler eklendi",
                },
                {
                    value: "tags-removed",
                    label: "Etiketler kaldırıldı",
                },
                {
                    value: "trigger-added",
                    label: "Tetikleyici eklendi",
                },
                {
                    value: "trigger-removed",
                    label: "Tetikleyici kaldırıldı",
                },
                {
                    value: "trigger-updated",
                    label: "Tetikleyici güncellendi",
                },
                {
                    value: "welcome-message-added",
                    label: "Karşılama mesajı eklendi",
                },
                {
                    value: "welcome-message-removed",
                    label: "Karşılama mesajı kaldırıldı",
                },
                {
                    value: "customer-group-added",
                    label: "Müşteri grubu eklendi",
                },
                {
                    value: "customer-group-removed",
                    label: "Müşteri grubu kaldırıldı",
                },
                {
                    value: "customer-group-updated",
                    label: "Müşteri grubu güncellendi",
                },
                {
                    value: "webhook-added",
                    label: "Webhook eklendi",
                },
                {
                    value: "webhook-removed",
                    label: "Webhook kaldırıldı",
                },
                {
                    value: "contact-prop-added",
                    label: "Kişi özelliği eklendi",
                },
                {
                    value: "contact-prop-removed",
                    label: "Kişi özelliği kaldırıldı",
                },
                {
                    value: "invoice-created",
                    label: "Fatura oluşturuldu",
                },
                {
                    value: "invoice-updated",
                    label: "Fatura güncellendi",
                },
                {
                    value: "invoice-payment-received",
                    label: "Fatura ödemesi alındı",
                },
                {
                    value: "invoice-payment-failed",
                    label: "Fatura ödemesi başarısız oldu",
                },
                {
                    value: "invoice-refunded",
                    label: "Fatura iade edildi",
                },
                {
                    value: "invoice-deleted",
                    label: "Fatura silindi",
                },
                {
                    value: "payment-method-added",
                    label: "Ödeme yöntemi eklendi",
                },
                {
                    value: "billing-address-updated",
                    label: "Fatura adresi güncellendi",
                },
                {
                    value: "plan-started",
                    label: "Plan başlatıldı",
                },
                {
                    value: "plan-canceled",
                    label: "Plan iptal edildi",
                },
                {
                    value: "task-workflow-created",
                    label: "Görev iş akışı oluşturuldu",
                },
                {
                    value: "task-workflow-deleted",
                    label: "Görev iş akışı silindi",
                },
                {
                    value: "task-created",
                    label: "Görev oluşturuldu",
                },
                {
                    value: "task-deleted",
                    label: "Görev silindi",
                },
                {
                    value: "task-stage-changed",
                    label: "Görev aşaması değiştirildi",
                },
                {
                    value: "task-assigned-to-user",
                    label: "Görev kullanıcıya atandı",
                },
                {
                    value: "task-update-priority",
                    label: "Görev önceliği güncellendi",
                },
                {
                    value: "task-added-tags",
                    label: "Göreve etiketler eklendi",
                },
                {
                    value: "chatbot-credit-low",
                    label: "Chatbot kredisi düşük",
                },
                {
                    value: "chatbot-credit-done",
                    label: "Chatbot kredisi tükendi",
                },
                {
                    value: "system-status",
                    label: "Sistem durumu",
                },
                {
                    value: "whatsapp-credit-low",
                    label: "WhatsApp kredisi düşük",
                },
                {
                    value: "reservation-created-plan",
                    label: "Rezervasyon planı oluşturuldu",
                },
                {
                    value: "reservation-updated-plan",
                    label: "Rezervasyon planı güncellendi",
                },
                {
                    value: "reservation-deleted-plan",
                    label: "Rezervasyon planı silindi",
                },
                {
                    value: "reservation-created",
                    label: "Rezervasyon oluşturuldu",
                },
                {
                    value: "reservation-updated",
                    label: "Rezervasyon güncellendi",
                },
                {
                    value: "reservation-deleted",
                    label: "Rezervasyon silindi",
                },
                {
                    value: "white-list-added",
                    label: "Beyaz liste eklendi",
                },
                {
                    value: "white-list-removed",
                    label: "Beyaz liste kaldırıldı",
                },
            ],
        };
    },
    methods: {
        ...mapActions({
            getUsers: "user/getUsers",
            getAdminUsers: "adminUser/getAdminUsers",
        }),
        getColumns() {
            console.log("getColumns", this.users);
            return [
                {
                    field: "",
                    key: "a",
                    type: "expand",
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "createdAt",
                    key: "createdAt",
                    title: this.$t("settings.dateAndTime"),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>;
                    },
                },
                {
                    field: "actor",
                    key: "actor",
                    title: this.$t("settings.actor"),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{this.getActorName(row)}</span>;
                    },
                    filter: {
                        filterList: [
                            {
                                value: "system",
                                label: "System (Supsis Ai)",
                                selected: this.filter.actorIds.includes("system"),
                            },
                            {
                                value: "chatbot",
                                label: "Chatbot",
                                selected: this.filter.actorIds.includes("chatbot"),
                            },
                            {
                                value: "api",
                                label: "API",
                                selected: this.filter.actorIds.includes("api"),
                            },
                            {
                                value: "visitor",
                                label: "Any Visitor",
                                selected: this.filter.actorIds.includes("visitor"),
                            },
                            {
                                value: "agent",
                                label: "Any Agent",
                                selected: this.filter.actorIds.includes("agent"),
                            },
                            ...this.users.map((user) => {
                                return {
                                    value: user._id,
                                    label: user.name,
                                    selected: this.filter.actorIds.includes(user._id),
                                };
                            }),
                            ...(this.isAdmin ? this.adminUsers : []).map((user) => {
                                return {
                                    value: user._id,
                                    label: `${user.name} (Admin User)`,
                                    selected: this.filter.actorIds.includes(user._id),
                                };
                            }),
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            this.filter.actorIds = filterList.filter((x) => x.selected).map((x) => x.value);
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.filter.actorIds = [];
                        },
                        // max height
                        maxHeight: 400,
                        width: 300,
                    },
                },
                {
                    field: "ipAddress",
                    key: "ipAddress",
                    title: "IP Address",
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        console.log("ipAddress.renderBodyCell", { row, column, rowIndex, h });
                        return (
                            <span class="text-bold" style="color:#1890ff;">
                                {row.ipAddress || "-"}
                            </span>
                        );
                    },
                },
                {
                    field: "type",
                    key: "type",
                    title: this.$t("settings.event"),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{this.activityTypeLabels[row.type] || row.type}</span>;
                    },
                    filter: {
                        filterList: this.activityTypes.map((activity) => {
                            return {
                                value: activity.value,
                                label: activity.label,
                                selected: this.filter.activityTypes.includes(activity.value),
                            };
                        }),
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            this.filter.activityTypes = filterList.filter((x) => x.selected).map((x) => x.value);
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.filter.activityTypes = [];
                        },
                        // max height
                        maxHeight: 400,
                        width: 300,
                    },
                },
            ];
        },
        loadNextPage() {
            this.cursor.page++;
            this.fetchActivities(true);
        },
        pageNumberChange(pageIndex) {
            this.cursor.page = pageIndex;
        },
        // page size change
        pageSizeChange(pageSize) {
            this.cursor.page = 1;
            this.cursor.perPage = pageSize;
        },
        updateFilters(filter) {
            this.filter = filter;
        },
        fetchActivities(concatMode = false) {
            this.loading = true;
            this.loadingInstance.show();
            ACTIVITY_API.ACTIVITY.list(this.cursor, this.filter)
                .then((response) => {
                    const { items } = response.data;
                    if (concatMode) {
                        this.activities = this.activities.concat(items);
                    } else {
                        this.activities = items;
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.loadingInstance.close();
                });
        },

        getActorName(activity) {
            if (activity.actor === "user") {
                return this.$_.get(activity, "actorUser.name");
            } else if (activity.actor === "admin-user") {
                return this.$_.get(activity, "actorUser.name", "");
            } else if (activity.actor === "visitor") {
                return this.$_.get(activity, "refVisitor.fullname");
            } else if (activity.actor === "chatbot") {
                return "Chatbot";
            } else if (activity.actor === "system") {
                return "System (Supsis Ai)";
            }
        },
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            adminUsers: (state) => state.adminUser.adminUsers.data,
            isAdmin: (state) => state.auth.adminUser != null,
        }),
        activityTypeLabels() {
            return this.activityTypes.reduce((labels, type) => {
                labels[type.value] = type.label;
                return labels;
            }, {});
        }
    },
    mounted() {
        VeLocale.use(this.tableConfig);
        this.loadingInstance = this.$veLoading({
            target: document.querySelector("#audit-logs-table"),
            name: "wave",
        });
        this.fetchActivities();
        if (this.isAdmin) {
            this.getAdminUsers({
                page: 1,
                perPage: 50,
            });
        }
    },
    watch: {
        filter: {
            deep: true,
            handler() {
                this.cursor.page = 1;
                this.fetchActivities();
            },
        },
        loading: {
            handler() {},
        },
    },
});
</script>

<style lang="scss">
#audit-logs {
    .actions {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
}
</style>
